import axios from 'axios';

const log = require("loglevel").getLogger("CoSellOpportunityService");
log.setLevel("error");

export const loadCoSellOpportunities = (accountName, selectedFilters, forceReload) => {
	const requestData = {
		accountName
	};

	return axios.post(`${process.env.REACT_APP_HOST_URL}/co-sell-opportunities/get`, requestData)
		.then(async response => {
			const res = response.data;
			log.debug("CoSellOpportunityService -> loadCoSellOpportunities -> return");
			return res;
		})
		.catch(response => {
			log.debug("CoSellOpportunityService -> loadCoSellOpportunities -> error: ");
			log.debug(response);
			return null;
		});
}; 